import * as React from "react";
import {Link} from "react-router-dom";
import { ll_url } from "../utils/tools";
import { toolTitle, toolVersion } from "../settings";
import ExtLink from "./ExtLink";

const Header = (props: { onClick?: () => void }) => (
  <header className="ll-header">
    <div className="ll-logo-tool">
      <Link to={ll_url('/')} onClick={props.onClick}>
        <img src={ll_url('/images/logos/predictonco.svg')} />
      </Link>
    </div>
    <div className="ll-version">v{toolVersion}</div>
    <div className="ll-horizontal-line"/>
    <div className="ll-description">
      {toolTitle}
    </div>
    <div className="ll-logo-loschmidt">
      <ExtLink to="https://loschmidt.chemi.muni.cz/"><img src={ll_url('/images/logos/ll.svg')} /></ExtLink>
    </div>
  </header>
);

export default Header;
